import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { OrganisationConfiguration } from '../../global.model';
import { ConfigAllService } from './config-all.abstract.service';
import { PatchOrganisationConfiguration } from './config-all.model';

@Injectable({
    providedIn: 'root',
})
export class ConfigAllImplService implements ConfigAllService {
    private baseUrl: string = environment.API_GATEWAY_URL;

    constructor(@Inject('HTTP_CLIENT') public http: HttpClient) {}

    public patchOrganisationConfiguration(body: PatchOrganisationConfiguration, orgTag: string): Observable<any> {
        console.log('patchOrganisationConfiguration', body, orgTag);
        let headers = new HttpHeaders().set('x-organisation', orgTag);

        return this.http.patch(`${this.baseUrl}/configurations/platform`, body, { headers: headers }).pipe(map((response: any) => response));
    }

    public getOrganisationConfiguration(tag: string) {
        return this.http
            .get(`${this.baseUrl}/configurations/platform`, {
                headers: new HttpHeaders({
                    'x-organisation': tag,
                }),
            })
            .pipe(map((response) => response as OrganisationConfiguration));
    }

    public getAllCoreConfig(): Observable<any> {
        let headers = new HttpHeaders().set('x-organisation', 'ALL');

        return this.http.get(`${this.baseUrl}/configurations/core`, { headers: headers }).pipe(map((r) => r));
    }
}

export const CONFIG_ALL_SERVICE_PROVIDER = {
    provide: ConfigAllService,
    useClass: ConfigAllImplService,
};
